/* eslint-disable no-useless-escape */
import { PasswordInput } from './'

interface IProps {
  [propName: string]: unknown
  requiredMessage?: string
  minLengthMessage?: string
  iconPlaceholder?: string
}

//TODO: Discuss splitting regex expression in two patterns: missing digits and missing symbols
/**
 * Returns an object containing validation rules for a password field.
 * @param {string} [requiredMessage='Check your password'] - The message to display when the password is required but not provided.
 * @param {string} [minLengthMessage='Password must be at least 10 characters long and include 1 number and 1 symbol'] - The message to display when the password is not at least 10 characters long.
 * @returns {object} An object containing validation rules for a password field, including a "required" rule, a "minLength" rule, and a "pattern" rule.
 */
const validation = (
  requiredMessage = 'Check your password',
  minLengthMessage = 'Password must be at least 10 characters long and include 1 number and 1 symbol',
) => {
  return {
    required: requiredMessage,
    minLength: {
      value: 10,
      message: minLengthMessage,
    },
    pattern: {
      // Special characters are defined by cognitos password policy
      // see this link for more information https://docs.aws.amazon.com/cognito/latest/developerguide/managing-users-passwords.html
      value:
        /(?=.*\d)(?=.*[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\\,\>\<\'\:\;\|\_\~\`\=\+\-]).*/,
      message: minLengthMessage,
    },
  }
}

export const PasswordInputWithValidation = (props: IProps): JSX.Element => {
  const { requiredMessage, minLengthMessage } = props
  return (
    <PasswordInput
      validation={validation(requiredMessage, minLengthMessage)}
      {...props}
    />
  )
}
